/* Native Shopify cart submission; no added library, tracking or cart interception. */
(() => {
  'use strict';
  if (window.cdRefonteV2Loaded) return;
  window.cdRefonteV2Loaded = true;
  const update = (card) => {
    const select = card.querySelector('[data-cv-variant]');
    if (!select) return;
    const option = select.options[select.selectedIndex] || select.options[0];
    if (!option) return;
    const available = option.dataset.available === 'true';
    const price = card.querySelector('[data-cv-price]');
    const stock = card.querySelector('[data-cv-stock]');
    const submit = card.querySelector('[data-cv-submit]');
    const more = card.querySelector('[data-cv-details]');
    const contact = card.querySelector('[data-cv-contact]');
    if (price) price.textContent = option.dataset.price || '';
    if (stock) stock.textContent = available ? 'Disponible en ligne' : 'Indisponible en ligne';
    if (submit) { submit.disabled = !available; submit.textContent = available ? 'Ajouter au panier' : 'Actuellement indisponible'; }
    if (contact) contact.hidden = available;
    if (more && option.dataset.url) more.setAttribute('href', option.dataset.url);
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-cv-card]').forEach((card) => {
      const select = card.querySelector('[data-cv-variant]');
      if (select && !select.dataset.cvBound) {
        select.addEventListener('change', () => update(card));
        select.dataset.cvBound = 'true';
      }
      update(card);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('pageshow', () => init());
})();
